const SELECTORS = {
  video: '.js-play-in-view'
}

class PlayInView {
  constructor () {
    this.elements = document.body.querySelectorAll(SELECTORS.video)

    this.init()
  }

  init() {
    const options = {
      root: null,
      rootMargin: '0%',
      threshold: 0.5
    }

    this.observer = new IntersectionObserver(entries => this.playVideo(entries), options)

    this.elements.forEach(element => {
      element.removeAttribute('autoplay')
      element.pause()
      element.currentTime = 0
      this.observer.observe(element)
    })
  }

  playVideo(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        this.observer.unobserve(entry.target)
        entry.target.play()
      }
    })
  }
}

/**
 * Add module objects alphabetically as needed
 * {
 *  selector: CSS selector for the target element(s)
 *  Source: Imported js class with a constructor. Constructor will be passed
 *      the target DOM element.
 * }
 */
export default {
  selector: 'body',
  Source: PlayInView
}
